<template>
  <div class="editor-field-container" :style="{ height: `${config.inputSize}px` }">
    <div class="editor-field" :class="{ active: config.active }">
      <div class="input" :style="{ height: `${config.inputSize}px` }" :class="{ active: config.active, red: config.color === 'red' || !config.color }">
        <input v-model="input" name="input" :disabled="!config.active" @change="setValue" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      required: true,
    },

    onChange: {
      type: Function,
      required: true,
    },

    value: {
      type: String,
      required: true,
    },

    config: {
      type: Object,
      required: false,

      default: () => ({
        inputSize: 48,
        active: false,
        color: null,
      }),
    },
  },

  data() {
    return {
      input: '',
    };
  },

  watch: {
    value(value) {
      this.input = value;
    },

    input() {
      this.onChange(this.input);
    },
  },

  mounted() {
    this.input = this.value;
  },

  methods: {
    setValue() {
      this.onChange(this.input);
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.editor-field-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  .input {
    margin: 0 0 16px;
    box-sizing: border-box;
    color: colors.$text-color;
    border: 1px solid transparent;

    input {
      width: 100%;
      height: 100%;
    }

    &.active {
      border-color: colors.$lightgrey-color;
      border-radius: 4px;
      background: colors.$white-color;
      padding: 4px 10px;
    }

    &:not(.active) {
      padding-top: 16px;
    }

    &:last-child {
      margin: 0;
    }

    &::placeholder {
      color: colors.$lightgrey-color;
    }
  }

  .editor-field {
    width: 100%;
    position: relative;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    justify-content: center;

    .input {
      width: 100%;
      color: colors.$lightgrey-color;
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
      position: relative;
      font-size: 14px;
      line-height: 16px;
      color: colors.$black-color;
      margin-bottom: 0;

      &.red {
        &.active {
          color: colors.$red-color;
        }
      }
    }
  }
}
</style>
